import { render, staticRenderFns } from "./issueStatusSummary.vue?vue&type=template&id=15590f67&scoped=true&"
import script from "./issueStatusSummary.vue?vue&type=script&lang=ts&"
export * from "./issueStatusSummary.vue?vue&type=script&lang=ts&"
import style0 from "./issueStatusSummary.vue?vue&type=style&index=0&id=15590f67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15590f67",
  null
  
)

export default component.exports